module.exports = __webpack_public_path__ + "static/media/24.7cd7115d.png";